import React from 'react';

import { Enquiry, ExpiredEnquiry, MarketplaceEligible, Vehicle, VehicleLookupState } from 'Utilities/vehicles/@types';

import { Slug } from '../utilities/profiling/@types';

export enum VehicleLookupActionType {
  LOOKUP_ADD = 'LOOKUP_ADD',
  LOOKUP_REMOVE = 'LOOKUP_REMOVE',
  LOOKUP_UPDATE = 'LOOKUP_UPDATE',
  LOOKUP_UPDATE_DP_STATE_SLUG = 'LOOKUP_UPDATE_DP_STATE_SLUG',
}

export type VehicleLookupPayload = {
  LOOKUP_ADD: {
    enquiry?: null | Enquiry | ExpiredEnquiry;
    resultError?: VehicleLookupState['resultError'];
    vehicle?: Partial<Vehicle>;
  };
  LOOKUP_UPDATE: {
    enquiry?: Partial<Enquiry>;
    marketplaceEligible?: Partial<MarketplaceEligible>;
    owned?: VehicleLookupState['owned'];
    showTrackerSignUp?: VehicleLookupState['showTrackerSignUp'];
    trackerMileage?: VehicleLookupState['trackerMileage'];
    vehicle?: Partial<Vehicle>;
  };
  LOOKUP_UPDATE_DP_STATE_SLUG: {
    dpEnquiryId?: number | null;
    dpStateSlug?: Slug | null;
  };
}

export type VehicleLookupAction = {
  payload: VehicleLookupPayload['LOOKUP_ADD'] | VehicleLookupPayload['LOOKUP_UPDATE'] | VehicleLookupPayload['LOOKUP_UPDATE_DP_STATE_SLUG'];
  type: VehicleLookupActionType;
}

export type VehicleLookupContextProps = {
  vehicleLookupActions: {
    add: (payload: VehicleLookupPayload['LOOKUP_ADD']) => void;
    remove: () => void;
    update: (payload: VehicleLookupPayload['LOOKUP_UPDATE']) => void;
    updateDpStateSlug: (payload: VehicleLookupPayload['LOOKUP_UPDATE_DP_STATE_SLUG']) => void;
  };
  vehicleLookupState: VehicleLookupState;
}

export type VehicleLookupProviderProps = {
  children: React.ReactNode;
  value?: VehicleLookupState;
}
